var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.884 14.111L18.059.778A1.268 1.268 0 0016.905 0h-4.067l.1.965a.334.334 0 01-.332.368h-1.213a.334.334 0 01-.332-.368l.1-.965H7.097a1.269 1.269 0 00-1.155.778L.117 14.111A1.331 1.331 0 001.273 16h8.2l.43-4.07a.667.667 0 01.663-.6h2.867a.667.667 0 01.663.6l.43 4.07h8.2a1.33 1.33 0 001.155-1.889zM10.851 2.965a.333.333 0 01.332-.3h1.637a.334.334 0 01.332.3l.192 1.816a.5.5 0 01-.5.552h-1.688a.5.5 0 01-.5-.552zM13.152 10h-2.3a.667.667 0 01-.663-.737l.211-2a.667.667 0 01.663-.6h1.881a.667.667 0 01.663.6l.211 2a.667.667 0 01-.666.737z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoad);
export default __webpack_public_path__ + "static/media/road.5abc8d7b4dfc6ca7802ecba08dbcb636.svg";
export { ForwardRef as ReactComponent };